const resources = {
    lead: 'Ouvrez une session pour une expérience plus personnalisée',
    signIn: 'Ouvrir une session',
    createAccount: 'Créer un compte'
};

module.exports = function getResource(label) {
    return resources[label];
};
